import Helpers from "../../commons/helpers";
import { HttpClient } from "./HttpClient";
import { Constants } from "../../constants/constants";


const HttpClientWorkerNode = (domainName: string) => {
    return HttpClient(domainName)
};

const WorkerNodeService = {

    async getPaged(domainName: string, data: any) {
        const query = Helpers.handleFormatParams(data);
        const result = await HttpClientWorkerNode(domainName).get(
            `${Constants.ApiPath.WORKER_NODE.GET_PAGED}?${query}`
        );
        return result.data.result;
    },

    async update(domainName: string, id: string) {
        const result = await HttpClientWorkerNode(domainName).post(
            Constants.ApiPath.WORKER_NODE.UPDATE,
            { id: id },
        );
        return result.data;
    },

}

export default WorkerNodeService